import { render, staticRenderFns } from "./section-period-table.vue?vue&type=template&id=3f242f67&scoped=true"
import script from "./section-period-table.vue?vue&type=script&lang=js"
export * from "./section-period-table.vue?vue&type=script&lang=js"
import style0 from "./section-period-table.vue?vue&type=style&index=0&id=3f242f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f242f67",
  null
  
)

export default component.exports